import styled from '@emotion/styled';
import { CSSProperties, FC } from 'react';

type Props = {
  style?: CSSProperties;
  className?: string;
};

const Content: FC<Props> = ({ className, children, style }) => {
  return (
    <Root className={className} style={style}>
      {children}
    </Root>
  );
};

const Root = styled('div')(`
  padding: 40px 24px;
  width: 540px;
  // footer分引いている
  height: calc(100% - 65px);
  position: relative;
  overflow-y: auto;
`);

export default Content;
